	// 파일 경로: src/firebaseConfig.js

import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getFunctions } from "firebase/functions";
import { getDatabase } from "firebase/database";
// [신규 추가] 애널리틱스 import
import { getAnalytics } from "firebase/analytics";

// .env 파일에서 Firebase 설정 정보를 안전하게 불러옵니다.
const firebaseConfig = {
  apiKey: "AIzaSyD8_0SFaNFN0DcwzDSYk-9G0kVw0k-sQSE",
  authDomain: "saltmate-project.firebaseapp.com",
  databaseURL: "https://saltmate-project-default-rtdb.asia-southeast1.firebasedatabase.app",
  projectId: "saltmate-project",
  storageBucket: "saltmate-project.firebasestorage.app",
  messagingSenderId: "285568911553",
  appId: "1:285568911553:web:9a3d95ab4060f3ab436c40",
  measurementId: "G-Q1MHZJH2B5"
};

// Firebase 초기화
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(app);
const functions = getFunctions(app, "asia-northeast3");
const rtdb = getDatabase(app);

// [신규 추가] 애널리틱스 초기화 및 export
const analytics = getAnalytics(app);

export { auth, db, storage, functions, rtdb, analytics };